import PropTypes from 'prop-types'
import Button from '@mui/material/Button';
//import styled from '@mui/material/styles';

const ActionButton = ({ sx = [], ...rest }) => {
    return (
        <Button {...rest}
        variant='contained'
        sx={[{
          lineHeight: 2.5,
          fontWeight: 'bold',
          letterSpacing: 1,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        />
    );
}
ActionButton.muiName = 'Button';
ActionButton.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

export default ActionButton
